import { ContentType } from '../../types/FormModelTypes';
const NODES = ['procent', 'procalma', 'procuso', 'procdest'];
const otOtrosValueText = new Map([
    ['procent_otros_c', 'Otros mecanismos de recogida'],
    ['procent_origen_c', 'Otro origen'],
    ['procent_verificaotros_c', 'Otro proceso de verificación'],
    ['procent_figuraotros_c', 'Otras figuras'],
    ['procalma_ubiotros_c', 'Otra ubicación'],
    ['procalma_figuraotros_c', 'Otras figuras'],
    ['procuso_otros_c', 'Otros mecanismos de autenticación'],
    ['procuso_figuraotros_c', 'Otras figuras'],
    ['procdest_figuraotros_c', 'Otras figuras'],
]);
export class AnswerProcessorService {
    constructor() {
        this.transformToOtResponses = (answers) => Object.entries(answers)
            .filter(([key]) => !key.endsWith('_details'))
            .flatMap(([key, value]) => {
            const [type] = key.split('_');
            if (Array.isArray(value)) {
                return value.map((v) => ({ type, value: String(v) }));
            }
            return [{ type, value: String(value) }];
        });
        this.composeEipdRequestBody = (otId, responses) => {
            const processNodes = NODES.reduce((acc, node) => (Object.assign(Object.assign({}, acc), { [node]: this.composeEntryNode(node, responses) })), {});
            const activosNodes = NODES.reduce((acc, node) => (Object.assign(Object.assign({}, acc), { [node]: this.composeActivosNode(node, responses) })), {});
            return Object.assign(Object.assign({}, processNodes), { relations: {
                    rel: [
                        Object.assign({ ot: {
                                Id: otId,
                                IsWeb: false,
                                OT_Obligatoria_c: false,
                                CONVERSIA_OpTratamientoDefaultValues_Id_c: 0,
                            } }, activosNodes),
                    ],
                } });
        };
        this.extractIds = (type, responses) => responses
            .filter((r) => r.type === type)
            .map((r) => Number(r.value))
            .filter((n) => !Number.isNaN(n) && n > 0);
        this.extractEntries = (type, responses) => responses.filter((r) => r.type === type && isNaN(Number(r.value))).map((r) => r.value);
        this.composeActivosNode = (type, responses) => this.extractIds(type, responses).map((id) => ({
            activo: { Id: id },
            triggered_computed_value: 'by user',
        }));
        this.composeEntryNode = (type, responses) => {
            const keys = new Set([...this.extractEntries(type, responses), `${type}_c`]);
            const node = {};
            for (const key of keys) {
                node[key] = otOtrosValueText.has(key) ? otOtrosValueText.get(key) : true;
            }
            return node;
        };
    }
    transformToFormResponse(answers) {
        const responses = [];
        const detailsMap = {};
        for (const [key, raw] of Object.entries(answers)) {
            if (!key.endsWith('_details'))
                continue;
            const parentKey = key.replace(/_details$/, '');
            const groups = [];
            if (Array.isArray(raw)) {
                for (const item of raw) {
                    groups.push({
                        content: Object.entries(item).map(([fieldKey, fieldVal]) => {
                            if (Array.isArray(fieldVal) && fieldVal.every((v) => typeof v === 'string')) {
                                const [entity] = fieldKey.split('_', 1);
                                const vars = fieldVal.map((s) => s.replace(`${entity}_`, ''));
                                return {
                                    contentId: fieldKey,
                                    valueType: ContentType.MULTIPLE,
                                    ocs_entity: entity,
                                    ocs_variable: null,
                                    ocs_variables: vars,
                                };
                            }
                            const [entity, ...rest] = fieldKey.split('_');
                            const variable = rest.join('_');
                            const strVal = String(fieldVal);
                            const vt = ['0', '1'].includes(strVal) ? ContentType.BINARY : ContentType.TEXT;
                            return {
                                contentId: fieldKey,
                                contentValue: strVal,
                                valueType: vt,
                                ocs_entity: entity,
                                ocs_variable: variable,
                            };
                        }),
                    });
                }
            }
            else if (raw && typeof raw === 'object') {
                if (key === 'cig_et_figuradpo_c_details') {
                    // los campos se procesan como respuestas independientes
                    for (const [fieldKey, fieldVal] of Object.entries(raw)) {
                        const [entity, ...rest] = fieldKey.split('_');
                        const variable = rest.join('_');
                        const strVal = String(fieldVal);
                        const vt = ['0', '1'].includes(strVal) ? ContentType.BINARY : ContentType.TEXT;
                        responses.push({
                            contentId: fieldKey,
                            contentValue: strVal,
                            valueType: vt,
                            ocs_entity: entity,
                            ocs_variable: variable,
                        });
                    }
                    continue;
                }
                else {
                    groups.push({
                        content: Object.entries(raw).map(([fieldKey, fieldVal]) => {
                            const [entity, ...rest] = fieldKey.split('_');
                            const variable = rest.join('_');
                            const strVal = String(fieldVal);
                            const vt = ['0', '1'].includes(strVal) ? ContentType.BINARY : ContentType.TEXT;
                            return {
                                contentId: fieldKey,
                                contentValue: strVal,
                                valueType: vt,
                                ocs_entity: entity,
                                ocs_variable: variable,
                            };
                        }),
                    });
                }
            }
            if (groups.length) {
                detailsMap[parentKey] = groups;
            }
        }
        for (const [key, raw] of Object.entries(answers)) {
            if (key.endsWith('_details'))
                continue;
            if (Array.isArray(raw) && raw.every((v) => typeof v === 'string')) {
                const [first] = raw;
                const [entity] = String(first).split('_', 1);
                const vars = raw.map((s) => s.replace(`${entity}_`, ''));
                responses.push({
                    contentId: key,
                    valueType: ContentType.MULTIPLE,
                    ocs_entity: entity,
                    ocs_variable: null,
                    ocs_variables: vars,
                });
                continue;
            }
            const str = String(raw);
            const vt = ['0', '1'].includes(str) ? ContentType.BINARY : ContentType.TEXT;
            const [entity, ...rest] = key.split('_');
            const variable = rest.join('_');
            const fr = {
                contentId: key,
                contentValue: str,
                valueType: vt,
                ocs_entity: entity,
                ocs_variable: variable,
            };
            if (detailsMap[key]) {
                fr.iterativeContent = detailsMap[key];
            }
            responses.push(fr);
        }
        for (const [parentKey, groups] of Object.entries(detailsMap)) {
            if (responses.some((r) => r.contentId === parentKey))
                continue;
            const [entity, ...rest] = parentKey.split('_');
            responses.push({
                contentId: parentKey,
                contentValue: '1',
                valueType: ContentType.BINARY,
                ocs_entity: entity,
                ocs_variable: rest.join('_'),
                iterativeContent: groups,
            });
        }
        return responses;
    }
    transformFromFormResponse(responses, formVersion) {
        const answers = {};
        const iterMap = {};
        if (formVersion === '') {
            answers['data_processing_types'] = [];
            answers['sanciones_types'] = [];
            answers['politica_procedimiento_types'] = [];
            answers['ms_soporte_types'] = [];
            answers['ms_modo_types'] = [];
            answers['ms_ubi_types'] = [];
            answers['delete_information_mechanism'] = [];
            const dataProcessing = ['s1.1-c8', 's1.1-c9', 's1.1-c10', 's1.1-c11'];
            const sanciones = ['s3.1-c13', 's3.1-c15'];
            const politicas = ['s3.5-c7', 's3.5-c8', 's3.5-c9', 's3.5-c10', 's3.5-c11'];
            for (const resp of responses) {
                const { contentId, contentValue, valueType, ocs_entity, ocs_variable, ocs_variables, iterativeContent } = resp;
                if (iterativeContent)
                    continue;
                if (valueType === ContentType.MULTIPLE && ocs_entity && ocs_variables && ocs_variable == null) {
                    switch (contentId) {
                        case 's1.1-c4':
                            answers['marketing_channels'] = ocs_variables.map((v) => `${ocs_entity}_${v}`);
                            break;
                        case 's3.3-c2':
                            answers['information_types'] = ocs_variables.map((v) => `${ocs_entity}_${v}`);
                            break;
                        case 's4.2-c2':
                            answers['servctrlhorario_types'] = ocs_variables.map((v) => `${ocs_entity}_${v}`);
                            break;
                        case 's4.3-c2':
                            answers['empherramientascontrolemp_types'] = ocs_variables.map((v) => `${ocs_entity}_${v}`);
                            break;
                        case 's3.2-c2':
                            answers['imparteformacionesempleados_types'] = ocs_variables.map((v) => `${ocs_entity}_${v}`);
                            break;
                    }
                    if (contentId === 's3.4-c13') {
                        answers['ms_soporte_types'].push(...ocs_variables.map((v) => `${ocs_entity}_${v}`));
                    }
                    if (contentId === 's3.4-c14')
                        answers['ms_modo_types'].push(...ocs_variables.map((v) => `${ocs_entity}_${v}`));
                    if (contentId === 's3.4-c15')
                        answers['ms_ubi_types'].push(...ocs_variables.map((v) => `${ocs_entity}_${v}`));
                    if (contentId === 's3.4-c17')
                        answers['delete_information_mechanism'].push(...ocs_variables.map((v) => `${ocs_entity}_${v}`));
                    continue;
                }
                if (ocs_entity && ocs_variable && contentValue != null) {
                    const key = `${ocs_entity}_${ocs_variable}`;
                    if (dataProcessing.includes(contentId) && contentValue === '1')
                        answers['data_processing_types'].push(key);
                    else if (sanciones.includes(contentId) && contentValue === '1')
                        answers['sanciones_types'].push(key);
                    else if (politicas.includes(contentId) && contentValue === '1')
                        answers['politica_procedimiento_types'].push(key);
                    else
                        answers[key] = contentValue;
                }
            }
            const dpdKeys = ['et_dponombre_c', 'et_dpoemail_c', 'et_dpotelefono_c', 'et_dpdfirmado_c', 'et_dpdcomunicado_c'];
            const dpdVals = responses
                .filter((r) => r.ocs_variable && dpdKeys.includes(r.ocs_variable))
                .reduce((acc, r) => {
                if (r.contentValue)
                    acc[`${r.ocs_entity}_${r.ocs_variable}`] = String(r.contentValue);
                return acc;
            }, {});
            answers['cig_et_figuradpo_c_details'] = dpdVals;
            for (const resp of responses) {
                const { ocs_entity, ocs_variable, contentValue, iterativeContent } = resp;
                if (!iterativeContent || !ocs_entity || !ocs_variable)
                    continue;
                const pk = `${ocs_entity}_${ocs_variable}`;
                if (pk === 'cig_et_figuradpo_c')
                    continue;
                if (contentValue != null)
                    answers[pk] = contentValue;
                iterMap[pk] = Array.isArray(iterativeContent) ? iterativeContent : [iterativeContent];
            }
            for (const [pk, groups] of Object.entries(iterMap)) {
                answers[`${pk}_details`] = groups.map((gr) => {
                    const obj = {};
                    gr.content.forEach((field) => {
                        if (field.valueType === ContentType.MULTIPLE && field.ocs_entity && field.ocs_variables)
                            obj[`${field.ocs_entity}_${field.ocs_variable || ''}`.replace(/_$/, '')] = field.ocs_variables.map((v) => `${field.ocs_entity}_${v}`);
                        else if (field.ocs_entity && field.ocs_variable && field.contentValue != null)
                            obj[`${field.ocs_entity}_${field.ocs_variable}`] = field.contentValue;
                    });
                    return obj;
                });
            }
        }
        else {
            for (const resp of responses) {
                if (resp.valueType === ContentType.INFO || resp.valueType === ContentType.MULTI_CONTENT)
                    continue;
                if (resp.valueType === ContentType.MULTIPLE && Array.isArray(resp.ocs_variables)) {
                    answers[resp.contentId] = resp.ocs_variables.map((v) => `${resp.ocs_entity}_${v}`);
                    continue;
                }
                if (resp.contentValue != null)
                    answers[resp.contentId] = resp.contentValue;
                if (resp.iterativeContent && resp.ocs_entity && resp.ocs_variable)
                    iterMap[`${resp.ocs_entity}_${resp.ocs_variable}`] = Array.isArray(resp.iterativeContent) ? resp.iterativeContent : [resp.iterativeContent];
            }
            for (const [pk, groups] of Object.entries(iterMap)) {
                answers[`${pk}_details`] = groups.map((gr) => {
                    const obj = {};
                    gr.content.forEach((field) => {
                        if (field.valueType === ContentType.MULTIPLE && field.ocs_entity && field.ocs_variables)
                            obj[field.contentId] = field.ocs_variables.map((v) => `${field.ocs_entity}_${v}`);
                        else if (field.contentValue != null)
                            obj[`${field.ocs_entity}_${field.ocs_variable}`] = field.contentValue;
                    });
                    return obj;
                });
            }
            const isDpoActive = responses.some((r) => r.contentId === 'cig_et_figuradpo_c' && r.contentValue === '1');
            if (isDpoActive) {
                const dpdFieldIds = new Set(['et_dponombre_c', 'et_dpoemail_c', 'et_dpotelefono_c', 'et_dpdfirmado_c', 'et_dpdcomunicado_c']);
                const dpdDetails = responses
                    .filter((r) => r.ocs_entity === 'cig' && r.ocs_variable && dpdFieldIds.has(r.ocs_variable))
                    .reduce((acc, r) => {
                    acc[`cig_${r.ocs_variable}`] = r.contentValue;
                    return acc;
                }, {});
                if (Object.keys(dpdDetails).length > 0) {
                    answers['cig_et_figuradpo_c_details'] = dpdDetails;
                    // Si quieres evitar duplicados planos:
                    for (const varId of dpdFieldIds) {
                        delete answers[`cig_${varId}`];
                    }
                }
            }
        }
        for (const key of Object.keys(answers)) {
            const val = answers[key];
            // 1) Arrays vacíos
            if (Array.isArray(val) && val.length === 0) {
                delete answers[key];
                continue;
            }
            // 2) Objetos vacíos
            if (val !== null &&
                typeof val === 'object' &&
                !Array.isArray(val) &&
                Object.getPrototypeOf(val) === Object.prototype &&
                Object.keys(val).length === 0) {
                delete answers[key];
                continue;
            }
        }
        return answers;
    }
    processMultiSelectAnswer(question, previous, changed) {
        var _a, _b;
        const isSelected = previous.includes(changed);
        let result = isSelected ? previous.filter((v) => v !== changed) : [...previous, changed];
        const exclusive = (_a = question.answers) === null || _a === void 0 ? void 0 : _a.find((a) => a.value === changed && a.exclusive);
        if (exclusive) {
            result = [changed];
        }
        else {
            // Si hay un exclusivo ya seleccionado y eliges otro → lo quitamos
            const exclusiveSelected = (_b = question.answers) === null || _b === void 0 ? void 0 : _b.find((a) => a.exclusive && result.includes(a.value));
            if (exclusiveSelected) {
                result = result.filter((v) => v !== exclusiveSelected.value);
            }
        }
        return result;
    }
}
